/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface CreateOptionDto
 */
export class CreateOptionDto {
    /**
     *
     * @type {string}
     * @memberof CreateOptionDto
     */
    optionName: CreateOptionDtoOptionNameEnum;
    /**
     *
     * @type {object}
     * @memberof CreateOptionDto
     */
    optionValue: object;
}

/**
 * @export
 * @enum {string}
 */
export enum CreateOptionDtoOptionNameEnum {
    ClusterLbs = 'cluster_lbs',
    General = 'general',
    PaymentIps = 'payment_ips',
    PaymentIpsDeployed = 'payment_ips_deployed',
    Languages = 'languages',
    PropOptions = 'PROP_OPTIONS',
}
